import { render } from "./BaseRelatedRecordCard.vue?vue&type=template&id=64800db4&scoped=true"
import script from "./BaseRelatedRecordCard.vue?vue&type=script&lang=js"
export * from "./BaseRelatedRecordCard.vue?vue&type=script&lang=js"

import "./BaseRelatedRecordCard.vue?vue&type=style&index=0&id=64800db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64800db4"]])

export default __exports__